var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



// WEBPACK FOOTER //
// ./node_modules/moment-timezone/index.js